import { CoinHistorySearchForm } from './AdjustCoinStatusSearchForm'
import { withAdjustCoinStatusSearchForm } from './withAdjustCoinStatusSearchForm'

const ConnectedAdjustCoinStatusSearchForm = withAdjustCoinStatusSearchForm(
  CoinHistorySearchForm
)

export { ConnectedAdjustCoinStatusSearchForm as AdjustCoinStatusSearchForm }
